'use strict';

var base = require('./base');
var catchHelper = require('catchsfra/catch/helper/catchHelper');

/* Globals bwp */
/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
    $('button.add-to-cart-global').attr('disabled', enableOrDisable);
}

// /**
//  * Set Label attribute
//  */
// function setLabelAttr() {
//     $('.attribute label.size').attr('for', $('.variation-btn.selected').attr('id'));
// }

$('document').ready(function () {
    var selectedVariation = $('.variation-btn.selected');
    if (selectedVariation) {
        selectedVariation.click();
    }

    base.setLabelAttr();

});

if ($('.singleVariant button.add-to-cart').is(':disabled') && $('.backInStockEnabled').length === 1) {
    $('.product-inventory-messaging').addClass('d-md-block');
    $('.AP-container, .AR-container, .product-actions, .promotions-container').hide();
}

/**
 * The function to send event to Facebook Conversion API
 */
function sendFBViewContentEventID() {
    var FBPixelEventID = window.FBViewContentEventID;
    var externalId = sfccExternalId ? sfccExternalId : '';
    var contentID = ($('.selected-variant-pid').val()) ? $('.selected-variant-pid').val() : $('.product-detail').data('pid');
    var capiData = {
        data: {
            content_ids: contentID,
            content_type: 'Product'
        },
        externalId: externalId
    };
    var form = {
        eventId: FBPixelEventID,
        eventType: 'ViewContent',
        capiData: JSON.stringify(capiData)
    };

    $.ajax({
        url: $('.js-facebookCapiURL').val(),
        type: 'POST',
        dataType: 'json',
        data: form,
        success: function (data) {},
        error: function (err) {}
    });
}

document.addEventListener('readystatechange', event => {
    if (event.target.readyState === 'complete') {
        sendFBViewContentEventID();
    }
});

module.exports = {
    methods: {
        updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements
    },

    availability: base.availability,
    addToCart: base.addToCart,
    images: base.images,

    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

            $productContainer.find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find('.description-and-detail .description')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .description .content')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find('.description-and-detail .description')
                    .addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer.find('.description-and-detail .details')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .details .content')
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find('.description-and-detail .details')
                    .addClass('hidden-xl-down');
            }
        });
    },

    showSpinner: function () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            $.spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            // Catch code start
            var calloutWidget = response.container.find('.catch-pdp-widget');
            if (calloutWidget.length !== 0) {
                catchHelper.onWidgetProductPriceChange();
                catchHelper.updateItemsAttributePDP(response);

                if (response.data.isVisibleCallout) {
                    catchHelper.showWidget(calloutWidget);
                } else {
                    catchHelper.hideWidget(calloutWidget);
                }
            }
            // Catch code end
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            if (response.product.available) {
                $('.AP-container, .AR-container, .product-actions, .promotions-container').show();
                $('.product-inventory-messaging').addClass('d-none');
            } else {
                $('.product-inventory-messaging').removeClass('d-none');
                $('.AP-container, .AR-container, .product-actions, .promotions-container').hide();
            }
            $('.selected-variant-pid').val(response.product.id);
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));

            var enable = $('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
            module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
            if (typeof bwp !== 'undefined') {
                bwp.updateWidget(response.product.id, 1, [response.product.id]);
            }
        });

        $(document).ready(function () {
            $(document).on('optin-changed', function () {
                if (window.OG.getOptins().length === 0) {
                    $('.bwp-btn-main').show().css('display', 'flex !important');
                    $(".catch-pdp-widget").show();
                } else {
                    $('.bwp-btn-main').hide();
                    $(".catch-pdp-widget").hide();
                }
            });
            $('og-offer').ready(function () {
                $(document).trigger('optin-changed');
            });
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);

            $('.availability-msg', response.$productContainer)
                .empty().html(response.message);

            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('available'); });

                var allReady = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },
    sizeChart: function () {
        $('.size-chart a').on('click', function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            var $prodSizeChart = $(this).closest('.size-chart').find('.size-chart-collapsible');
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    }
                });
            }
            $prodSizeChart.toggleClass('active');
        });

        var $sizeChart = $('.size-chart-collapsible');
        $('body').on('click touchstart', function (e) {
            if ($('.size-chart').has(e.target).length <= 0) {
                $sizeChart.removeClass('active');
            }
        });
    },
    copyProductLink: function () {
        $('body').on('click', '#fa-link', function () {
            event.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').attr('role', 'alert');
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },
    setProduct: function () {
        if (window.OrdergrooveLegacyOffers) {
            $('.og-offer').ready(function () {
                if (window.OG && window.OG.setProduct) {
                    window.OG.setProduct({
                        id: $('.product-detail').data('pid'),
                        module: $('.og-offer').data('og-module'),
                        quantity: $('.product-detail').find('.quantity-select').val()
                    });
                }
            });
        }
    },
    updateProduct: function () {
        $('body').on('product:afterAttributeSelect', function () {
            if (window.OrdergrooveLegacyOffers) {
                if (window.OG && window.OG.setProduct) {
                    window.OG.setProduct({
                        id: $('.product-detail').data('pid'),
                        module: $('.og-offer').data('og-module'),
                        quantity: $('.product-detail').find('.quantity-select').val()
                    });
                }
            } else {
                $('og-offer').attr('product', $('.product-detail').data('pid'));
            }
        });
    },
    setQuantity: function () {
        if (window.OrdergrooveLegacyOffers) {
            $(document).on('change', '.quantity-select', function (e) {
                e.preventDefault();
                if (window.OG && window.OG.setQuantity) {
                    window.OG.setQuantity({
                        id: $('.product-detail').data('pid'),
                        module: $('.og-offer').data('og-module'),
                        quantity: $(this).val()
                    });
                }
            });
        }
    },
    updateCart: function () {
        if (window.OrdergrooveLegacyOffers) {
            $('body').on('product:afterAddToCart', function () {
                if (window.OG && window.OG.updateCart) {
                    window.OG.updateCart({
                        id: $('.product-detail').data('pid'),
                        module: $('.og-offer').data('og-module'),
                        quantity: $('.product-detail').find('.quantity-select').val()
                    });
                }
            });
        }
    },
    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),
    ogWidget: function () {
        let styleGeneral = document.createElement('style');
        let styleOgRoot = document.createElement('style');

        styleOgRoot.textContent = `
            span[slot="confirm"] {
                float: right;
                padding: 15px 44px;
                color: #fff;
                position: relative;
                background-color: #272728;
                border-color: transparent;
                border-radius: 2.25rem;
                overflow: hidden;
                z-index: 0;
                font-size: 0.75rem;
                line-height: 0.9375rem;
                letter-spacing: 0.0625rem;
                text-decoration: none;
                margin-left: 20px;
            }

            span[slot="cancel"] {
                float: right;
                padding: 15px 0;
                text-decoration: underline;
            }
        `;

        styleGeneral.textContent = `
            .og-modal__container {
                position: relative;
                padding: 0 30px 30px !important;
                max-width: 640px !important;
                width: 100%;
            }

            .og-modal__header {
                position: absolute;
                right: 10px;
                top: 16px;
            }

            .og-modal__close:before {
                font-size: 19px;
            }

            .og-modal__content {
                margin-top: 0 !important;
            }
        `;

        function initializeOgWidget() {
            const modalElements = document.querySelectorAll('og-upsell-modal');

            modalElements.forEach(modalElement => {
                if (modalElement) {
                    const shadowRoot = modalElement.shadowRoot;
                    shadowRoot.appendChild(styleOgRoot.cloneNode(true));

                    // Update confirmation label text
                    shadowRoot.querySelector('og-text[key="upsellModalConfirmLabel"]').textContent = 'ADD NOW';

                    const modalContent = shadowRoot.querySelector('og-modal');
                    setTimeout(() => {
                        if (modalContent) {
                            modalContent.shadowRoot.appendChild(styleGeneral.cloneNode(true));
                        }
                    }, 200);
                }
            });
        }

        initializeOgWidget();
    }
};
